<script type="text/javascript">
export default {
  props: {
    source: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <div class="code-bg">
    <vue-json-pretty :data="source" :deep="1"/>
    <div class="extra">
      <div class="extra">
        <a-button type="link" icon="copy" size="small"
                  @click="copy(JSON.stringify(source, null, 1), 'Source has been successfully copied to your clipboard.')"/>
      </div>
    </div>
  </div>
</template>
